import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { HostOnboardingProvider } from '../../context/HostOnboardingContext';

interface HostOnboardingProps {
  children: React.ReactNode;
}

const HostOnboarding = ({ children }: HostOnboardingProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // If user lands on /host/onboarding without a step, redirect to step 1
    if (location.pathname === '/host/onboarding' || location.pathname === '/host/onboarding/') {
      navigate('/host/onboarding/step-1', { replace: true });
    }
  }, [location.pathname, navigate]);

  return (
    <HostOnboardingProvider>
      {children}
    </HostOnboardingProvider>
  );
};

export default HostOnboarding;
